
(() => {
  if (window.apostelHeartGiftInstalled) return;
  window.apostelHeartGiftInstalled = true;
  const originalFetch = window.fetch.bind(window);
  const shirtId = 15751960494411;
  const giftId = 56402554454347;
  const marker = 'jesus-loves-you';
  const root = window.Shopify?.routes?.root || '/';
  let pending = Promise.resolve();

  const jsonRequest = async (path, body) => {
    const response = await originalFetch(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    });
    const data = await response.json();
    if (!response.ok || data.status || data.errors) throw new Error(data.description || data.message || 'Cart update failed');
    return data;
  };

  const readCart = async () => {
    const response = await originalFetch(root + 'cart.js');
    if (!response.ok) throw new Error('Cart unavailable');
    return response.json();
  };

  const syncGift = async (cart, sections, sectionsUrl) => {
    const wanted = cart.items.some(item => item.product_id === shirtId && item.quantity > 0) ? 1 : 0;
    const gifts = cart.items.filter(item => item.variant_id === giftId && item.properties?._apostel_gift === marker);
    const current = gifts.reduce((sum, item) => sum + item.quantity, 0);
    if (wanted === current && gifts.length <= 1) return null;
    const rendering = sections.length ? { sections, sections_url: sectionsUrl } : {};
    let updated;
    if (!gifts.length && wanted > 0) {
      await jsonRequest('cart/add.js', { items: [{ id: giftId, quantity: wanted, properties: { _apostel_gift: marker } }] });
      updated = await jsonRequest('cart/update.js', rendering);
    } else {
      const updates = {};
      gifts.forEach((item, index) => { updates[item.key] = index === 0 ? wanted : 0; });
      updated = await jsonRequest('cart/update.js', { updates, ...rendering });
    }
    const paidGifts = updated.items.filter(item => item.variant_id === giftId && item.properties?._apostel_gift === marker && item.final_line_price > 0);
    if (paidGifts.length) {
      const updates = {};
      paidGifts.forEach(item => { updates[item.key] = 0; });
      updated = await jsonRequest('cart/update.js', { updates, ...rendering });
    }
    return updated;
  };

  window.fetch = function(input, init) {
    let url;
    try { url = new URL(typeof input === 'string' || input instanceof URL ? input : input.url, location.href); }
    catch { return originalFetch(input, init); }
    const method = (init?.method || (input instanceof Request ? input.method : 'GET')).toUpperCase();
    const action = url.pathname.match(/\/cart\/(add|change|update)(?:\.js)?$/)?.[1];
    if (url.origin !== location.origin || method !== 'POST' || !action) return originalFetch(input, init);
    const run = async () => {
      const response = await originalFetch(input, init);
      if (!response.ok) return response;
      let data;
      try { data = await response.clone().json(); } catch { return response; }
      if (data.status || data.errors) return response;
      const sections = Object.keys(data.sections || {});
      const cart = action === 'add' ? await readCart() : data;
      if (!Array.isArray(cart.items)) return response;
      let sectionsUrl = location.pathname;
      const body = init?.body;
      if (body instanceof FormData) sectionsUrl = body.get('sections_url') || sectionsUrl;
      else if (typeof body === 'string') {
        try { sectionsUrl = JSON.parse(body).sections_url || sectionsUrl; } catch {}
      }
      const updated = await syncGift(cart, sections, sectionsUrl);
      if (!updated) return response;
      if (action === 'add') {
        const refreshLine = line => {
          const match = updated.items.find(item => item.variant_id === (line.variant_id || line.id) && JSON.stringify(item.properties || {}) === JSON.stringify(line.properties || {}));
          return match ? { ...line, key: match.key } : line;
        };
        if (data.items) data.items = data.items.map(refreshLine);
        else data = refreshLine(data);
        data.sections = updated.sections || data.sections;
      } else data = updated;
      return new Response(JSON.stringify(data), { status: response.status, statusText: response.statusText, headers: { 'Content-Type': 'application/json' } });
    };
    const result = pending.then(run, run);
    pending = result.catch(() => {});
    return result;
  };
})();

class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);

    this.dispatchCartViewEvent();
  }

  // The notification's outer element is server-rendered once at page load, so
  // its `cart` Liquid object reflects the pre-add state. The morphed children
  // (inserted from the /cart/add.js sections response in renderContents) are
  // post-add, but they don't expose the full cart shape we need for the event
  // payload. So we keep an explicit /cart.json fetch on open. Migrating to the
  // factory + filter would require re-rendering the notification element
  // itself in sections, which is out of scope for this PR.
  async dispatchCartViewEvent() {
    const { CartViewEvent } = window.StandardEvents || {};
    if (!CartViewEvent) return;

    try {
      const response = await fetch(`${routes.cart_url}.json`);
      const cart = await response.json();
      if (!cart?.currency) return;

      this.dispatchEvent(
        new CartViewEvent({
          context: 'dialog',
          cart: CartViewEvent.createCartFromAjaxResponse(cart),
        })
      );
    } catch (e) {
      // cart:view is informational; swallow fetch errors
    }
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);

